'use strict';

var get = require('lodash/get');
var uniq = require('lodash/uniq');

var buildSimpleValidator = require('./helpers/build-simple-validator');

module.exports = buildSimpleValidator(function (value, validationOptions) {
  if (get(validationOptions, 'caseInsensitiveUnique', false)) {
    var valueWithLowercaseStrings = value.map(function (item) {
      return typeof item === 'string' ? item.toLowerCase() : item;
    });

    return uniq(valueWithLowercaseStrings).length === value.length;
  }

  return uniq(value).length === value.length;
}, 'All items must be unique');